/* 365nails homepage experience release: 365nails-homepage-brand-ui-v17-stable-render + mobile-performance-r2 + shopify-files-focus-v2 + stable-service-scenes-v1 */
/* 365nails-homepage-service-scenes-v2: generated */
const homepageStableScenePolicyVersion = "homepage-approved-service-artwork-v2";
const homepageStableSceneAssets = {"ready-wholesale":{"filename":"365-homepage-hero-wholesale-v1.jpg","assetFilename":"365-homepage-scene-wholesale-v3.webp","assetDigest":"f0ac0ba43ccd3ecee9a7261413aa1845a8e7365c38e57982bb6cdb657f5e9057","datasetKey":"homepageSceneWholesaleUrl","alt":"365nails sample portfolio and six press-on nail styles for wholesale selection"},"brand-ready":{"filename":"365-homepage-hero-private-label-v1.jpg","assetFilename":"365-homepage-scene-custom-v3.webp","assetDigest":"a7bb1accadd16ae2eaa623a73f72beb419184f3b795d805aa30e11922446af97","datasetKey":"homepageSceneCustomUrl","alt":"365nails design portfolio, nail sketches and samples beside blank client packaging"},"dropshipping":{"filename":"365-homepage-hero-dropshipping-v1.jpg","assetFilename":"365-homepage-scene-dropshipping-v3.webp","assetDigest":"3c0e18d7c93883c1d5b8bea8c664bee37c9fcc2750a5b87d8b463d02f8a3875e","datasetKey":"homepageSceneDropshippingUrl","alt":"365nails supplier workstation with an online nail shop and one unbranded order being packed"}};
/* end-365nails-homepage-service-scenes-v2 */

const homepageHeroAutoplayDelay = 4000;
const homepageMerchandisingTimeoutMs = 5000;

const localizedStorefrontPath = (value) =>
  globalThis.__365StorefrontRoutes?.path?.(value) || value;

const setDatasetValue = (element, key, value) => {
  if (element && element.dataset[key] !== value) {
    element.dataset[key] = value;
  }
};

const setTextValue = (element, value) => {
  if (element && element.textContent.trim() !== value) {
    element.textContent = value;
  }
};

const setAttributeValue = (element, name, value) => {
  if (element && element.getAttribute(name) !== value) {
    element.setAttribute(name, value);
  }
};

const interpolateHomepageCopy = (value, parameters) => String(value).replace(
  /\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/gu,
  (match, name) => Object.hasOwn(parameters, name) ? String(parameters[name]) : match,
);

const homepageCopy = (key, fallback, parameters = {}) => interpolateHomepageCopy(
  globalThis.__365StorefrontI18n?.t?.(key, parameters, { fallback }) || fallback,
  parameters,
);

const homepageSection = (suffix, descendant = "") => {
  const wrapper = document.querySelector(`[id$="__${suffix}"]`);
  return descendant ? wrapper?.querySelector?.(descendant) || null : wrapper;
};

const homepageMerchandisingPublicManifestSchema =
  "365nails-homepage-merchandising-public/v2";
const homepageWeeklyFocusLegacySchema = "365nails-homepage-weekly-focus/v1";
const homepageWeeklyFocusSchema = "365nails-homepage-weekly-focus/v2";
const homepageHeroMediaMaintenanceMode = "stable-service-scenes";
const homepageHeroStyleRoles = [
  "ready-wholesale",
  "brand-ready",
  "dropshipping",
  "live-selection",
];
let homepageMerchandisingManifest = null;

const runHomepageR2Task = (callback) => {
  try {
    const result = callback?.();
    result?.catch?.(() => {});
  } catch {
    // Preserve the native theme if a non-critical homepage enhancement cannot run.
  }
};

const scheduleHomepageR2Idle = (callback) => {
  if (typeof globalThis.requestIdleCallback === "function") {
    globalThis.requestIdleCallback(() => runHomepageR2Task(callback), { timeout: 1800 });
    return;
  }
  if (typeof globalThis.requestAnimationFrame === "function") {
    globalThis.requestAnimationFrame(() => runHomepageR2Task(callback));
    return;
  }
  runHomepageR2Task(callback);
};

const isValidHomepageMerchandisingManifest = (value) => {
  if (
    !value
    || value.schemaVersion !== homepageMerchandisingPublicManifestSchema
    || value.status !== "active"
    || typeof value.cycleId !== "string"
    || typeof value.manifestHash !== "string"
    || !value.sections
  ) return false;

  const sectionTypes = {
    "new-arrivals": "product",
    "hot-products": "product",
    "best-sellers": "product",
    "flash-deals": "product",
    "custom-products": "product",
    "featured-series": "collection",
  };
  const sectionsValid = Object.entries(sectionTypes).every(([sectionId, resourceType]) => {
    const items = value.sections[sectionId];
    return Array.isArray(items) && items.length > 0 && items.every((item) => (
      item
      && typeof item.id === "string"
      && typeof item.title === "string"
      && /^[^\s\/?#<>"'`\\]{1,255}$/u.test(item.handle)
      && typeof item.imageUrl === "string"
      && /^(?:https:|\/\/)/u.test(item.imageUrl)
      && item.resourceType === resourceType
    ));
  });
  return sectionsValid;
};

const isValidHomepageWeeklyFocusBase = (focus) => focus
    && /^\d{4}-W\d{2}$/u.test(focus.weekId)
    && homepageHeroStyleRoles.includes(focus.role)
    && focus.slotIndex === homepageHeroStyleRoles.indexOf(focus.role)
    && /^[a-f0-9]{64}$/u.test(focus.assetDigest)
    && typeof focus.alt === "string"
    && focus.alt.length > 0;

const isValidHomepageWeeklyFocusAssetUrl = (value) => {
  if (typeof value !== "string") return false;
  try {
    const url = new URL(value);
    return url.protocol === "https:"
      && url.hostname === "cdn.shopify.com"
      && url.pathname.startsWith("/s/files/");
  } catch {
    return false;
  }
};

const normalizeHomepageWeeklyFocus = (focus) => {
  // Cached v1/v2 manifests contain whole-image collages, not service-safe product regions.
  if (homepageHeroMediaMaintenanceMode === "stable-service-scenes") return null;
  if (!isValidHomepageWeeklyFocusBase(focus)) return null;
  if (
    focus.schemaVersion === homepageWeeklyFocusLegacySchema
    && /^365-homepage-focus-\d{4}-w\d{2}-[a-z-]+\.jpg$/u.test(focus.assetFilename)
  ) return focus;
  if (
    focus.schemaVersion === homepageWeeklyFocusSchema
    && focus.storage === "shopify-files"
    && /^365-homepage-focus-\d{4}-w\d{2}-[a-z-]+-[a-f0-9]{16}\.jpg$/u.test(focus.assetFilename)
    && focus.assetFilename.endsWith(`${focus.assetDigest.slice(0, 16)}.jpg`)
    && isValidHomepageWeeklyFocusAssetUrl(focus.assetUrl)
  ) return focus;
  return null;
};

const homepageMerchandisingAssetUrl = () => {
  const script = Array.from(document.scripts || []).find((item) =>
    item.src.includes("365-homepage-experience.js"));
  if (!script?.src) return null;
  try {
    return new URL(
      script.dataset.homepageMerchandisingUrl
        || "365-homepage-merchandising.json",
      script.src,
    ).toString();
  } catch {
    return null;
  }
};

const loadHomepageMerchandisingManifest = async (signal) => {
  const url = homepageMerchandisingAssetUrl();
  if (!url || !globalThis.fetch) return null;
  try {
    const response = await fetch(url, {
      credentials: "same-origin",
      cache: "force-cache",
      signal,
    });
    if (!response.ok) return null;
    const payload = await response.json();
    if (!isValidHomepageMerchandisingManifest(payload)) return null;
    return {
      ...payload,
      weeklyFocus: normalizeHomepageWeeklyFocus(payload.weeklyFocus),
    };
  } catch {
    return null;
  }
};

const homepageHeroNativeSlideCount = 4;

const homepageServiceSceneAssetUrl = (scene) => {
  const script = Array.from(document.scripts || []).find((item) =>
    item.src.includes("365-homepage-experience.js"));
  if (!script?.src) return null;
  try {
    const mapped = script.dataset?.[scene.datasetKey];
    const url = new URL(mapped || scene.assetFilename, script.src);
    if (!/^(?:https?:|file:)$/u.test(url.protocol)) return null;
    // Liquid asset_url owns CDN versions. Imports/fixtures use the artwork hash,
    // never the parent's JS version or an unversioned relative dependency.
    if (!mapped || !url.searchParams.has("v")) url.searchParams.set("v", scene.assetDigest);
    return url.toString();
  } catch {
    return null;
  }
};

const applyHomepageApprovedServiceArtwork = (media) => {
  const filename = value => {
    try { return new URL(value, "https://365nails.com/").pathname.split("/").pop(); }
    catch { return null; }
  };
  Array.from(media?.querySelectorAll?.(".swiper-slide") || []).forEach(slide => {
    const images = Array.from(slide.querySelectorAll("img"));
    const sceneEntry = Object.entries(homepageStableSceneAssets).find(([, scene]) =>
      images.length > 0 && images.every(img =>
        [scene.filename, scene.assetFilename].includes(filename(img.getAttribute("src")))));
    if (!sceneEntry) return;
    const [role, scene] = sceneEntry;
    const imageUrl = homepageServiceSceneAssetUrl(scene);
    if (!imageUrl) return;
    // Do not replace a merchant's distinct mobile/picture image or srcset.
    const responsive = Array.from(slide.querySelectorAll("source, img"));
    if (responsive.some(el => (el.getAttribute("srcset") || "").split(",").filter(s => s.trim())
      .some(s => ![scene.filename, scene.assetFilename].includes(filename(s.trim().split(/\s+/u)[0]))))) return;
    responsive.forEach(el => setAttributeValue(el, "srcset", imageUrl));
    images.forEach(img => {
      setAttributeValue(img, "src", imageUrl);
      setAttributeValue(img, "alt", homepageCopy(
        `homepage.hero.artwork.${role}.alt`,
        img.getAttribute("alt") || scene.alt,
      ));
      img.removeAttribute("data-src");
      img.removeAttribute("data-srcset");
    });
    setDatasetValue(slide, "mediaRole", role);
    setDatasetValue(slide, "serviceScene", "v2");
  });
  setDatasetValue(media, "heroMediaPolicy", homepageStableScenePolicyVersion);
};

const getNativeHomepageHeroSlides = (layer) => Array.from(
  layer?.querySelectorAll?.(".swiper-slide") || [],
).filter((slide) => !slide.classList?.contains("swiper-slide-duplicate"));

const decorateNativeHomepageHeroSlides = (mediaSlides, contentSlides) => {
  if (
    mediaSlides.length !== homepageHeroNativeSlideCount
    || contentSlides.length !== homepageHeroNativeSlideCount
  ) return false;

  const roles = contentSlides.map((slide, index) => {
    const role = homepageHeroStyleRoles[index];
    const mediaSlide = mediaSlides[index];
    setDatasetValue(mediaSlide, "mediaRole", role);
    setDatasetValue(mediaSlide, "mediaFit", "cover");
    setDatasetValue(slide, "contentRole", role);
    return role;
  });

  return roles.length === homepageHeroNativeSlideCount
    && roles.every(Boolean)
    && new Set(roles).size === homepageHeroNativeSlideCount;
};

const homepageWeeklyFocusAssetUrl = (focus) => {
  if (focus.schemaVersion === homepageWeeklyFocusSchema) {
    return isValidHomepageWeeklyFocusAssetUrl(focus.assetUrl)
      ? focus.assetUrl
      : null;
  }
  const script = Array.from(document.scripts || []).find((item) =>
    item.src.includes("365-homepage-experience.js"));
  if (!script?.src) return null;
  try {
    const url = new URL(focus.assetFilename, script.src);
    url.searchParams.set("v", focus.assetDigest);
    return url.toString();
  } catch {
    return null;
  }
};

const updateHomepageHeroMediaSlide = (slide, focus, imageUrl) => {
  if (!slide) return false;
  slide.querySelectorAll?.("source").forEach((source) => {
    setAttributeValue(source, "srcset", imageUrl);
  });
  const images = Array.from(slide.querySelectorAll?.("img") || []);
  images.forEach((image) => {
    setAttributeValue(image, "src", imageUrl);
    setAttributeValue(image, "srcset", imageUrl);
    setAttributeValue(image, "alt", focus.alt);
    image.removeAttribute?.("data-src");
    image.removeAttribute?.("data-srcset");
  });
  setDatasetValue(slide, "weeklyFocusWeek", focus.weekId);
  setDatasetValue(slide, "weeklyFocusRole", focus.role);
  return images.length > 0;
};

const applyHomepageWeeklyFocus = () => {
  if (homepageHeroMediaMaintenanceMode === "stable-service-scenes") return false;
  const focus = homepageMerchandisingManifest?.weeklyFocus;
  if (!focus) return false;
  const hero = document.querySelector(".image-with-text-slider image-with-text-slider");
  const media = hero?.querySelector?.(".image-slider__media");
  const nativeSlides = getNativeHomepageHeroSlides(media);
  const target = nativeSlides[focus.slotIndex];
  if (!target || target.dataset.mediaRole !== focus.role) return false;
  const imageUrl = homepageWeeklyFocusAssetUrl(focus);
  if (!imageUrl) return false;
  const changed = updateHomepageHeroMediaSlide(target, focus, imageUrl);
  Array.from(media?.querySelectorAll?.(".swiper-slide-duplicate") || [])
    .filter((slide) => slide.dataset.swiperSlideIndex === String(focus.slotIndex))
    .forEach((slide) => updateHomepageHeroMediaSlide(slide, focus, imageUrl));
  if (!changed) return false;
  setDatasetValue(hero, "weeklyFocusWeek", focus.weekId);
  setDatasetValue(hero, "weeklyFocusRole", focus.role);
  return true;
};

const enhanceHomepageHero = () => {
  const hero = document.querySelector(".image-with-text-slider image-with-text-slider");
  if (!hero || hero.dataset.brandV2 === "four-focus") return;

  const legacyMedia = hero.querySelector(".image-slider__media");
  const content = hero.querySelector(".image-slider__content");
  const mediaSlides = getNativeHomepageHeroSlides(legacyMedia);
  const contentSlides = getNativeHomepageHeroSlides(content);

  if (!decorateNativeHomepageHeroSlides(mediaSlides, contentSlides)) {
    setDatasetValue(hero, "brandV2NativeState", "requires-four-native-blocks");
    return;
  }

  applyHomepageApprovedServiceArtwork(legacyMedia);
  setDatasetValue(legacyMedia, "brandV2Layer", "media");
  setDatasetValue(content, "brandV2Layer", "content");
  const contentSlider = content?.querySelector(".swiper");
  const prefersReducedMotion = globalThis.matchMedia?.("(prefers-reduced-motion: reduce)")
    ?.matches === true;
  const mobileViewport = globalThis.matchMedia?.("(max-width: 767.98px)")?.matches === true;
  const themeEditorActive = globalThis.Shopify?.designMode === true;

  if (contentSlider && (prefersReducedMotion || themeEditorActive || mobileViewport)) {
    contentSlider.swiper?.autoplay?.stop?.();
    setDatasetValue(
      hero,
      "brandV2Autoplay",
      themeEditorActive
        ? "theme-editor-paused"
        : mobileViewport ? "mobile-paused" : "reduced-motion",
    );
  } else if (contentSlider) {
    // One slider owns the autoplay clock; the native component synchronizes its media peer.
    setDatasetValue(contentSlider, "autoplay", String(homepageHeroAutoplayDelay));
    if (contentSlider.swiper?.params?.autoplay) {
      contentSlider.swiper.params.autoplay.delay = homepageHeroAutoplayDelay;
      contentSlider.swiper.params.autoplay.disableOnInteraction = false;
      contentSlider.swiper.autoplay?.start?.();
    }
    setDatasetValue(hero, "brandV2Autoplay", `${homepageHeroAutoplayDelay}ms`);
  }
  setDatasetValue(hero, "brandV2", "four-focus");
  setDatasetValue(hero, "brandV2Media", "native-four-focus");
  setAttributeValue(
    hero,
    "aria-label",
    homepageCopy(
      "homepage.hero.aria_label",
      "365nails wholesale, customization, dropshipping, and live product selection",
    ),
  );

  if (!document.querySelector(".homepage-v2-trust")) {
    const trust = document.createElement("aside");
    const eyebrow = document.createElement("p");
    const heading = document.createElement("h2");
    const list = document.createElement("ul");
    const facts = [
      [
        homepageCopy("homepage.trust.clear_moq.title", "Clear MOQ"),
        homepageCopy(
          "homepage.trust.clear_moq.description",
          "Buying rules stay visible before you commit.",
        ),
      ],
      [
        homepageCopy("homepage.trust.real_product_checks.title", "Real product checks"),
        homepageCopy(
          "homepage.trust.real_product_checks.description",
          "Review styles and quality details before ordering.",
        ),
      ],
      [
        homepageCopy("homepage.trust.custom_packaging.title", "Custom packaging"),
        homepageCopy(
          "homepage.trust.custom_packaging.description",
          "Connect nails, cards, cases, and branded packaging.",
        ),
      ],
      [
        homepageCopy("homepage.trust.global_fulfillment.title", "Global fulfillment"),
        homepageCopy(
          "homepage.trust.global_fulfillment.description",
          "Choose wholesale shipping or dropshipping support.",
        ),
      ],
    ];

    trust.className = "homepage-v2-trust page-width page-width--fixed";
    trust.setAttribute("aria-labelledby", "HomepageV2TrustHeading");
    setDatasetValue(trust, "brandV2", "compact-proof");
    eyebrow.className = "homepage-v2-trust__eyebrow visually-hidden";
    eyebrow.textContent = homepageCopy(
      "homepage.trust.eyebrow",
      "Procurement confidence",
    );
    heading.id = "HomepageV2TrustHeading";
    heading.className = "homepage-v2-trust__heading visually-hidden";
    heading.textContent = homepageCopy("homepage.trust.heading", "Sourcing facts");
    list.className = "homepage-v2-trust__list";

    facts.forEach(([title, description]) => {
      const item = document.createElement("li");
      const itemTitle = document.createElement("strong");
      const itemDescription = document.createElement("span");
      itemTitle.textContent = title;
      itemDescription.className = "visually-hidden";
      itemDescription.textContent = description;
      item.append(itemTitle, itemDescription);
      list.append(item);
    });

    trust.append(eyebrow, heading, list);
    const heroSection = hero.closest?.(".shopify-section");
    heroSection?.insertAdjacentElement?.("afterend", trust);
  }
};

const bindHomepageHeroThemeEditor = () => {
  if (
    globalThis.Shopify?.designMode !== true
    || document.documentElement?.dataset?.homepageHeroEditorBound === "true"
  ) return;

  setDatasetValue(document.documentElement, "homepageHeroEditorBound", "true");
  document.addEventListener?.("shopify:section:load", enhanceHomepageHero);
  document.addEventListener?.("shopify:block:select", () => {
    const contentSlider = document.querySelector(
      ".image-with-text-slider image-with-text-slider .image-slider__content .swiper",
    );
    contentSlider?.swiper?.autoplay?.stop?.();
  });
};

const enhanceBuyerPaths = () => {
  [
    document.querySelector(".buyer-next-step"),
    document.querySelector(".homepage-product-paths-wrapper"),
  ].forEach((section) => {
    if (!section || section.dataset.brandV2 === "hero-owned") return;
    section.hidden = true;
    setAttributeValue(section, "aria-hidden", "true");
    setDatasetValue(section, "brandV2", "hero-owned");
  });
};

const homepageProofFacts = [
  homepageCopy("homepage.proof.clear_moq", "Clear MOQ and wholesale pricing"),
  homepageCopy("homepage.proof.custom_packaging", "Custom packaging available"),
  homepageCopy("homepage.proof.worldwide_shipping", "Worldwide shipping support"),
  homepageCopy("homepage.proof.quality_checks", "Quality checks before shipment"),
  homepageCopy("homepage.proof.real_product_videos", "Real product videos available"),
  homepageCopy("homepage.proof.factory_direct", "Factory-direct sourcing"),
];

const enhanceHomepageProofStrip = () => {
  const section = homepageSection("scrolling_promotion_peW4K8", ".section--scrolling-promotion")
    || document.querySelector(".section--scrolling-promotion");
  if (!section || section.dataset.brandV2 === "bounded-proof") return;

  section.querySelectorAll(".promotion__text").forEach((item, index) => {
    setTextValue(item, homepageProofFacts[index % homepageProofFacts.length]);
  });

  setDatasetValue(section, "brandV2", "bounded-proof");
};

const enhanceHomepageCategoryDiscovery = () => {
  const section = homepageSection("collection_list_slider_6qbNfj", ".collection-list-slider");
  if (!section || section.dataset.brandV2 === "swipe-discovery") return;

  const header = section.querySelector(".section__header");
  const content = section.querySelector(".section__content");
  if (!header || !content) return;

  let action = header.querySelector(".homepage-v16-section-action");
  if (!action) {
    action = document.createElement("a");
    action.className = "homepage-v16-section-action";
    action.href = localizedStorefrontPath("/collections/all");
    action.textContent = homepageCopy("search.view_all", "View all");
    header.append(action);
  }

  setAttributeValue(content, "aria-label", homepageCopy(
    "homepage.category.aria_label",
    "Swipe through product categories",
  ));
  setDatasetValue(section, "brandV2", "swipe-discovery");
};

enhanceHomepageHero();
bindHomepageHeroThemeEditor();
enhanceBuyerPaths();
enhanceHomepageProofStrip();
enhanceHomepageCategoryDiscovery();

const homepageProductCollectionConfig = [
  {
    sectionId: "hot-products",
    handle: "hot-products",
    eyebrow: homepageCopy(
      "homepage.products.hot_products.eyebrow",
      "Popular with wholesale buyers",
    ),
    heading: homepageCopy("homepage.products.hot_products.heading", "Hot Products"),
    description: homepageCopy(
      "homepage.products.hot_products.description",
      "Explore press-on nail styles attracting strong buyer interest right now.",
    ),
    action: homepageCopy(
      "homepage.products.hot_products.action",
      "View Hot Products",
    ),
    placement: "lead",
  },
  {
    sectionId: "new-arrivals",
    handle: "new-arrivals",
    eyebrow: homepageCopy(
      "homepage.products.new_arrivals.eyebrow",
      "Fresh for your assortment",
    ),
    heading: homepageCopy("homepage.products.new_arrivals.heading", "New Arrivals"),
    description: homepageCopy(
      "homepage.products.new_arrivals.description",
      "Start with the newest press-on nail styles added for wholesale buyers.",
    ),
    action: homepageCopy(
      "homepage.products.new_arrivals.action",
      "View New Arrivals",
    ),
    placement: "middle",
  },
  {
    sectionId: "best-sellers",
    handle: "best-sellers",
    eyebrow: homepageCopy(
      "homepage.products.best_sellers.eyebrow",
      "Proven buyer favorites",
    ),
    heading: homepageCopy(
      "homepage.products.best_sellers.module_heading",
      "Best Sellers",
    ),
    description: homepageCopy(
      "homepage.products.best_sellers.description",
      "Start with proven styles that help wholesale buyers test demand with less guesswork.",
    ),
    action: homepageCopy(
      "homepage.products.best_sellers.module_action",
      "View Best Sellers",
    ),
    placement: "tail",
  },
];

const formatHomepagePrice = (value) => {
  const amount = Number.parseFloat(value);
  if (!Number.isFinite(amount)) return "";
  return new Intl.NumberFormat(document.documentElement?.lang || "en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(amount);
};

const buildHomepageProductImage = (value) => {
  if (!value) return null;
  try {
    const source = new URL(value, globalThis.location?.origin || "https://365nails.com");
    const isShopifyAsset = source.hostname.endsWith("shopify.com")
      || source.pathname.startsWith("/cdn/shop/");
    if (!isShopifyAsset) return { src: source.toString(), srcset: "" };

    const candidate = (width) => {
      const url = new URL(source);
      url.searchParams.set("width", String(width));
      return url.toString();
    };
    return {
      src: candidate(480),
      srcset: [240, 480, 720].map((width) => `${candidate(width)} ${width}w`).join(", "),
    };
  } catch {
    return { src: value, srcset: "" };
  }
};

const updateHomepageProductCard = (card, product) => {
  const href = localizedStorefrontPath(`/products/${encodeURIComponent(product.handle)}`);
  const imageUrl = product.imageUrl
    || product.images?.[0]?.src
    || product.image?.src
    || "";
  const priceValue = product.price ?? product.variants?.[0]?.price;
  const compareAtPriceValue = product.compare_at_price
    ?? product.variants?.[0]?.compare_at_price;
  const price = formatHomepagePrice(priceValue);
  const compareAtPrice = formatHomepagePrice(compareAtPriceValue);
  const isOnSale = Number.parseFloat(compareAtPriceValue) > Number.parseFloat(priceValue);

  card.querySelectorAll("a[href]").forEach((link) => {
    setAttributeValue(link, "href", href);
    if (link.hasAttribute("aria-label")) {
      setAttributeValue(link, "aria-label", product.title);
    }
  });

  const image = card.querySelector(".product-card__image img");
  if (image && imageUrl) {
    const responsiveImage = buildHomepageProductImage(imageUrl);
    image.src = responsiveImage?.src || imageUrl;
    if (responsiveImage?.srcset) {
      image.srcset = responsiveImage.srcset;
      image.sizes = "(max-width: 767px) 50vw, 20vw";
    }
    image.alt = product.title;
    image.loading = "lazy";
    image.decoding = "async";
    image.removeAttribute("is");
    setAttributeValue(image, "fetchpriority", "low");
    image.closest(".media-wrapper")?.classList.remove("loading");
  }

  setTextValue(card.querySelector(".product-card__title .reversed-link__text"), product.title);
  const titleLink = card.querySelector(".product-card__title a");
  setAttributeValue(titleLink, "data-product-card-title-full", product.title);
  setAttributeValue(titleLink, "data-product-card-title-short", product.title);

  const priceBlock = card.querySelector(".f-price");
  const saleBlock = priceBlock?.querySelector(".f-price__sale");
  const salePrice = saleBlock?.querySelector(".f-price-item--sale");
  const compareAtPriceElement = saleBlock?.querySelector(".f-price-item--regular s");
  const regularPrice = priceBlock?.querySelector(".f-price__regular .f-price-item--regular");
  const displayPrice = price
    ? homepageCopy(
      "homepage.products.from_per_set",
      "From {{price}} / set",
      { price },
    )
    : "";

  if (isOnSale && saleBlock && salePrice && compareAtPriceElement) {
    priceBlock.classList.add("f-price--on-sale");
    setTextValue(salePrice, displayPrice);
    setTextValue(compareAtPriceElement, compareAtPrice);
    setTextValue(regularPrice, "");
  } else {
    card.querySelector(".product-card__badge")?.remove();
    saleBlock?.remove();
    priceBlock?.classList.remove("f-price--on-sale");
    setTextValue(regularPrice, displayPrice);
  }
  card.querySelectorAll(
    ".product-card__list-actions, [data-product-quick-view], [data-quick-add]",
  ).forEach((item) => item.remove());
};

const updateHomepageProductCollectionHeader = (wrapper, config) => {
  setTextValue(wrapper.querySelector(".rich-text__subheading"), config.eyebrow);
  setTextValue(
    wrapper.querySelector(".rich-text__heading motion-element")
      || wrapper.querySelector(".rich-text__heading"),
    config.heading,
  );
  setTextValue(wrapper.querySelector(".rich-text__text"), config.description);

  const action = wrapper.querySelector(".section__header--buttons a");
  setTextValue(
    action?.querySelector(".btn__text") || action,
    config.action,
  );
  setAttributeValue(
    action,
    "href",
    localizedStorefrontPath(`/collections/${encodeURIComponent(config.handle)}`),
  );
};

const buildHomepageProductCollection = (sourceWrapper, config, products) => {
  const clone = sourceWrapper.cloneNode(true);
  clone.removeAttribute("id");
  clone.querySelectorAll("[id], [data-id]").forEach((item) => {
    item.removeAttribute("id");
    item.removeAttribute("data-id");
  });
  clone.querySelectorAll("script").forEach((script) => script.remove());
  clone.querySelectorAll("motion-element").forEach((item) => {
    item.removeAttribute("data-motion");
    item.removeAttribute("data-motion-delay");
    item.removeAttribute("style");
  });
  clone.classList.add("homepage-product-collection");
  setDatasetValue(clone, "homepageCollection", config.handle);

  updateHomepageProductCollectionHeader(clone, config);

  const cards = Array.from(clone.querySelectorAll(".product-card"));
  cards.forEach((card, index) => {
    const column = card.closest(".f-column");
    const product = products[index];
    if (!product) {
      column?.remove();
      return;
    }
    updateHomepageProductCard(card, product);
  });

  return clone;
};

const loadHomepageCollectionProducts = async (config, limit = 5, signal) => {
  const response = await fetch(
    localizedStorefrontPath(`/collections/${config.handle}/products.json?limit=${limit}`),
    { credentials: "same-origin", signal },
  );
  if (!response.ok) throw new Error(`Collection request failed: ${config.handle}`);
  const payload = await response.json();
  const localizedProducts = (payload.products || []).slice(0, limit);
  const manifestProducts = homepageMerchandisingManifest?.sections?.[config.sectionId];
  if (!Array.isArray(manifestProducts) || manifestProducts.length < limit) {
    return localizedProducts;
  }

  const localizedByHandle = new Map(
    localizedProducts.map((product) => [product.handle, product]),
  );
  return manifestProducts.slice(0, limit).map((product) => {
    const localizedProduct = localizedByHandle.get(product.handle);
    return {
      ...localizedProduct,
      ...product,
      price: localizedProduct?.variants?.[0]?.price ?? product.price,
      title: localizedProduct?.title || product.title,
    };
  });
};

const enhanceHomepageProductCollections = async (signal) => {
  if (!globalThis.fetch) return false;
  if (homepageProductCollectionConfig.every((config) => (
    document.querySelector(`[data-homepage-collection='${config.handle}']`)
  ))) return true;

  const bestSellerWrapper = homepageSection("featured_collection_bdaamt");
  const legacyDeals = document.querySelector(".countdown-with-multi")?.closest(".shopify-section");
  const legacyTrends = document.querySelector(".horizontal-products-list")?.closest(".shopify-section");
  const productStackAnchor = homepageSection("collection_list_slider_6qbNfj")
    || document.querySelector(".collection-list-slider")?.closest?.(".shopify-section");
  if (!bestSellerWrapper || !legacyDeals || !legacyTrends || !productStackAnchor) return false;

  try {
    const collectionResponses = await Promise.all(
      homepageProductCollectionConfig.map(async (config) => ({
        config,
        products: await loadHomepageCollectionProducts(config, 5, signal),
      })),
    );
    if (collectionResponses.some(({ products }) => products.length === 0)) return false;

    const byPlacement = new Map(
      collectionResponses.map((entry) => [entry.config.placement, entry]),
    );
    const lead = byPlacement.get("lead");
    const middle = byPlacement.get("middle");
    const tail = byPlacement.get("tail");
    if (!lead || !middle || !tail) return false;

    // Build both clones before touching the live DOM. The three rail moves then finish
    // synchronously in one rendering turn, at the former sourcing-evidence position.
    const hotProducts = buildHomepageProductCollection(
      bestSellerWrapper,
      lead.config,
      lead.products,
    );
    const newArrivals = buildHomepageProductCollection(
      bestSellerWrapper,
      middle.config,
      middle.products,
    );

    updateHomepageProductCollectionHeader(bestSellerWrapper, tail.config);
    Array.from(bestSellerWrapper.querySelectorAll(".product-card"))
      .forEach((card, index) => {
        if (tail.products[index]) updateHomepageProductCard(card, tail.products[index]);
      });
    setDatasetValue(bestSellerWrapper, "homepageCollection", tail.config.handle);

    const existingEvidence = document.querySelector(".homepage-v2-evidence");
    if (existingEvidence) {
      existingEvidence.replaceWith(hotProducts);
    } else {
      productStackAnchor.insertAdjacentElement("afterend", hotProducts);
    }
    hotProducts.insertAdjacentElement("afterend", newArrivals);
    newArrivals.insertAdjacentElement("afterend", bestSellerWrapper);
    legacyDeals.remove();
    legacyTrends.remove();
    return true;
  } catch {
    // Preserve the native homepage modules if the collection endpoint is unavailable.
    return false;
  }
};

const enhanceHomepageCustomProducts = async (signal) => {
  if (!globalThis.fetch) return;

  const section = homepageSection("featured_collection_CrTARf", ".featured-collection");
  if (!section || section.dataset.homepageCustomProducts === "product-only") return;

  const items = section.querySelector(".featured-collection__items");
  const promotionalColumn = Array.from(items?.children || [])
    .find((column) => column.querySelector?.(".card-media")
      && !column.querySelector?.(".product-card"));
  const sourceProductCard = items?.querySelector?.(".product-card");
  const sourceProductColumn = sourceProductCard?.closest?.(".f-column");
  if (!promotionalColumn || !sourceProductColumn) return;

  const cleanProductColumn = (column) => {
    column.querySelectorAll("[id], [data-id]").forEach((item) => {
      item.removeAttribute("id");
      item.removeAttribute("data-id");
    });
    column.querySelectorAll("script").forEach((script) => script.remove());
    column.querySelectorAll("motion-element").forEach((item) => {
      item.removeAttribute("data-motion");
      item.removeAttribute("data-motion-delay");
      item.removeAttribute("style");
    });
    return column;
  };

  try {
    const products = await loadHomepageCollectionProducts({
      sectionId: "custom-products",
      handle: "private-label",
    }, 5, signal);
    const manifestProducts = homepageMerchandisingManifest?.sections?.["custom-products"];
    if (Array.isArray(manifestProducts) && manifestProducts.length >= 5) {
      const existingProductColumns = Array.from(items.children)
        .filter((column) => column.querySelector?.(".product-card"));
      const template = cleanProductColumn(sourceProductColumn.cloneNode(true));
      existingProductColumns.forEach((column) => column.remove());
      promotionalColumn.remove();

      products.slice(0, 5).forEach((product, index) => {
        const productColumn = index < existingProductColumns.length
          ? cleanProductColumn(existingProductColumns[index])
          : template.cloneNode(true);
        const productCard = productColumn.querySelector(".product-card");
        if (!productCard) return;
        updateHomepageProductCard(productCard, product);
        items.append(productColumn);
      });
      setDatasetValue(section, "homepageCustomProducts", "manifest");
      return;
    }

    const replacementProduct = products[4];
    if (!replacementProduct) return;

    const productColumn = cleanProductColumn(sourceProductColumn.cloneNode(true));

    const productCard = productColumn.querySelector(".product-card");
    if (!productCard) return;
    updateHomepageProductCard(productCard, replacementProduct);
    promotionalColumn.replaceWith(productColumn);
    setDatasetValue(section, "homepageCustomProducts", "product-only");
  } catch {
    // Keep the merchant-configured section intact if the collection endpoint is unavailable.
  }
};

const homepageTopSeries = [
  {
    title: "3D Water Tube",
    href: "/collections/liquid-motion-press-ons",
    image: "//365nails.com/cdn/shop/collections/IMG_E4628.jpg?v=1776737877&width=900",
  },
  {
    title: "Cat Eye",
    href: "/collections/cat-eye",
    image: "//365nails.com/cdn/shop/collections/screenshot-20250730-085152.png?v=1753836751&width=900",
  },
  {
    title: "Crystal Luxury",
    href: "/collections/crystal-luxury",
    image: "//365nails.com/cdn/shop/collections/O1CN01DCmC5d22SYgO3eUB3__2219370087119-0-cib.jpg?v=1767273153&width=900",
  },
  {
    title: "Dragon Claw",
    href: "/collections/dragon-claw",
    image: "//365nails.com/cdn/shop/collections/7e60852bf732f78a3ea06878760081c4.jpg?v=1764325532&width=900",
  },
  {
    title: "Sculpted Flora",
    href: "/collections/sculpted-flora",
    image: "//365nails.com/cdn/shop/collections/c099e5267d3180141400c91b19b221b1.jpg?v=1767575408&width=900",
  },
  {
    title: "Femme Fatale",
    href: "/collections/femme-fatale",
    image: "//365nails.com/cdn/shop/collections/4b775fd3a3c68a4d1de5efc4d36e30ca.jpg?v=1771386469&width=900",
  },
  {
    title: "Dark Rebel",
    href: "/collections/dark-rebel",
    image: "//365nails.com/cdn/shop/collections/O1CN01B1wZGk1rlpWt19d1F__2215158925672-0-cib.jpg?v=1766826318&width=900",
  },
  {
    title: "Cartoon & Dopamine",
    href: "/collections/cartoon-dopamine",
    image: "//365nails.com/cdn/shop/collections/d6c53bbf6b079c56535debb8eb10dd33.jpg?v=1771295174&width=900",
  },
  {
    title: "Solid Color",
    href: "/collections/solid-color-1",
    image: "//365nails.com/cdn/shop/collections/jimeng-2025-11-25-3316.png?v=1764030522&width=900",
  },
  {
    title: "Rhinestone",
    href: "/collections/rhinestone",
    image: "//365nails.com/cdn/shop/files/O1CN01It3ueZ1CPwH3Yb59C__2213196780074-0-cib.jpg?v=1753689594&width=900",
  },
];

const withHomepageImageWidth = (url, width) => url.replace(
  /([?&])width=\d+/,
  `$1width=${width}`,
);

const enhanceHomepageTopSeries = () => {
  const section = homepageSection("collection_list_yzwnVQ", ".collection-list");
  if (!section || section.dataset.brandV2 === "top-series") return;

  const cards = Array.from(section.querySelectorAll("a.collection-card__wrapper")).slice(0, 10);
  const localizedTitles = new Map(cards.map((card) => {
    const href = card.getAttribute("href") || "";
    const handle = href.split("/collections/")[1]?.split(/[/?#]/u, 1)?.[0];
    const title = card.querySelector(".collection-card__title span")?.textContent?.trim();
    return [handle, title];
  }).filter(([handle, title]) => handle && title));
  const manifestSeries = homepageMerchandisingManifest?.sections?.["featured-series"];
  const series = Array.isArray(manifestSeries) && manifestSeries.length >= 10
    ? manifestSeries.slice(0, 10).map((item) => ({
        title: item.title,
        href: `/collections/${encodeURIComponent(item.handle)}`,
        image: item.imageUrl,
      }))
    : homepageTopSeries;
  if (cards.length < series.length) return;

  cards.forEach((card, index) => {
    const item = series[index];
    const image = card.querySelector("img");
    const handle = item.href.split("/collections/")[1]?.split(/[/?#]/u, 1)?.[0];
    const title = localizedTitles.get(handle) || item.title;
    setAttributeValue(card, "href", localizedStorefrontPath(item.href));
    setTextValue(card.querySelector(".collection-card__title span"), title);
    setAttributeValue(card.querySelector(".collection-card__btn"), "aria-label", title);
    if (image) {
      image.src = item.image;
      image.alt = title;
      image.loading = "lazy";
      image.decoding = "async";
      setAttributeValue(image, "fetchpriority", "low");
      image.setAttribute(
        "srcset",
        [360, 535, 750, 900]
          .map((width) => `${withHomepageImageWidth(item.image, width)} ${width}w`)
          .join(", "),
      );
    }
  });
  setDatasetValue(section, "brandV2", "top-series");
};

const homepageDiscoverySections = Object.freeze([
  {
    suffix: "collection_list_yzwnVQ",
    label: "Shop by Series",
    kind: "series",
  },
  {
    suffix: "buttons_with_icon_XJn7cx",
    label: "Shop by MOQ",
    kind: "moq",
  },
  {
    suffix: "brand_logos_mtjpT9",
    label: "Shop by Shape",
    kind: "shape",
  },
]);

const enhanceHomepageDiscoveryHeadings = () => {
  homepageDiscoverySections.forEach(({ suffix, label }) => {
    const wrapper = homepageSection(suffix);
    if (!wrapper) return;
    const heading = wrapper.querySelector(".section__header .rich-text__heading motion-element")
      || wrapper.querySelector(".section__header .rich-text__heading");
    setTextValue(heading, label);
    setDatasetValue(wrapper, "homepageDiscovery", "full-width");
  });
};

const homepageCustomBrandItems = Object.freeze([
  {
    titleKey: "search.customization",
    title: "Custom nail designs",
    action: "Start a custom design",
    href: "/pages/customization",
    imageUrl: "https://i.ytimg.com/vi/QCMcdqL3vaE/maxresdefault.jpg",
    imageAlt: "Custom press-on nail design review",
  },
  {
    titleKey: "homepage.trust.custom_packaging.title",
    title: "Branded packaging",
    action: "Explore packaging",
    href: "/pages/private-label-packaging",
    imageUrl: "https://cdn.shopify.com/s/files/1/0918/6066/4603/files/f7daf6eeca8b9543e19b6ad010f6b5d0.png",
    imageAlt: "365nails branded private-label packaging",
  },
  {
    titleKey: "search.business_inquiry",
    title: "Private label support",
    action: "View private label support",
    href: "/pages/business-inquiry",
    imageUrl: "https://i.ytimg.com/vi/I0IcdWit9xI/maxresdefault.jpg",
    imageAlt: "365nails private-label sourcing support",
  },
]);

const enhanceHomepageCustomBrand = () => {
  if (document.querySelector(".homepage-v16-custom-brand")) return;
  const source = homepageSection("featured_collection_CrTARf");
  const discoveryAnchor = homepageSection("brand_logos_mtjpT9");
  if (!source || !discoveryAnchor) return;

  const section = document.createElement("section");
  const header = document.createElement("div");
  const headerText = document.createElement("div");
  const heading = document.createElement("h2");
  const description = document.createElement("p");
  const overallAction = document.createElement("a");
  const grid = document.createElement("div");

  section.className = "homepage-v16-custom-brand page-width page-width--fixed";
  section.setAttribute("aria-labelledby", "HomepageV16CustomBrandHeading");
  setDatasetValue(section, "brandV2", "custom-brand-paths");
  header.className = "homepage-v16-custom-brand__header";
  headerText.className = "homepage-v16-custom-brand__header-text";
  heading.id = "HomepageV16CustomBrandHeading";
  heading.className = "homepage-v16-custom-brand__heading";
  heading.textContent = homepageCopy(
    "homepage.custom_brand.heading",
    "Custom & Brand",
  );
  description.className = "homepage-v16-custom-brand__description";
  description.textContent = homepageCopy(
    "search.business_context",
    "Create custom nail designs, branded packaging, and private-label collections.",
  );
  overallAction.className = "homepage-v16-custom-brand__overall-action";
  overallAction.href = localizedStorefrontPath("/pages/customization");
  overallAction.textContent = homepageCopy("search.view_all", "View all");
  grid.className = "homepage-v16-custom-brand__grid";

  homepageCustomBrandItems.forEach((item) => {
    const card = document.createElement("a");
    const image = document.createElement("img");
    const body = document.createElement("span");
    const title = document.createElement("strong");
    const action = document.createElement("span");

    card.className = "homepage-v16-custom-brand__card";
    card.href = localizedStorefrontPath(item.href);
    image.className = "homepage-v16-custom-brand__image";
    image.src = item.imageUrl;
    image.alt = item.imageAlt;
    image.width = 960;
    image.height = 640;
    image.loading = "lazy";
    image.decoding = "async";
    setAttributeValue(image, "fetchpriority", "low");
    body.className = "homepage-v16-custom-brand__body";
    title.className = "homepage-v16-custom-brand__title";
    title.textContent = homepageCopy(item.titleKey, item.title);
    action.className = "homepage-v16-custom-brand__action";
    action.textContent = item.action;
    body.append(title, action);
    card.append(image, body);
    grid.append(card);
  });

  headerText.append(heading, description);
  header.append(headerText, overallAction);
  section.append(header, grid);
  discoveryAnchor.insertAdjacentElement("afterend", section);

  source.hidden = true;
  setAttributeValue(source, "aria-hidden", "true");
  setDatasetValue(source, "brandV2", "replaced-by-custom-brand-paths");
};

const bootstrapHomepageMerchandising = async () => {
  setDatasetValue(document.documentElement, "homepagePerformanceR2", "eager-atomic-merchandising");
  setDatasetValue(document.documentElement, "homepageMerchandisingState", "loading");

  const controller = typeof globalThis.AbortController === "function"
    ? new globalThis.AbortController()
    : null;
  const timeout = globalThis.setTimeout?.(
    () => controller?.abort?.("homepage-merchandising-timeout"),
    homepageMerchandisingTimeoutMs,
  );

  try {
    homepageMerchandisingManifest = await loadHomepageMerchandisingManifest(controller?.signal);
    applyHomepageWeeklyFocus();
    const [collectionsReady] = await Promise.all([
      enhanceHomepageProductCollections(controller?.signal),
      enhanceHomepageCustomProducts(controller?.signal),
    ]);
    if (!collectionsReady) {
      setDatasetValue(document.documentElement, "homepageMerchandisingState", "fallback");
      return;
    }

    enhanceHomepageTopSeries();
    enhanceHomepageDiscoveryHeadings();
    enhanceHomepageCustomBrand();
    if (homepageMerchandisingManifest) {
      setDatasetValue(
        document.documentElement,
        "homepageMerchandisingCycle",
        homepageMerchandisingManifest.cycleId,
      );
      setDatasetValue(
        document.documentElement,
        "homepageMerchandisingManifest",
        homepageMerchandisingManifest.manifestHash,
      );
      if (homepageMerchandisingManifest.weeklyFocus) {
        setDatasetValue(
          document.documentElement,
          "homepageWeeklyFocus",
          homepageMerchandisingManifest.weeklyFocus.weekId,
        );
      }
    }
    setDatasetValue(document.documentElement, "homepageMerchandisingState", "ready");
  } catch {
    setDatasetValue(document.documentElement, "homepageMerchandisingState", "fallback");
  } finally {
    if (timeout !== undefined) globalThis.clearTimeout?.(timeout);
  }
};

// Start before the customer can scroll into the product stack. The legacy sections stay
// as a no-JS/failure fallback, but CSS suppresses their first paint while this settles.
runHomepageR2Task(bootstrapHomepageMerchandising);

const scheduleHomepageDiscoveryR2 = () => {
  scheduleHomepageR2Idle(() => {
    enhanceHomepageTopSeries();
    enhanceHomepageDiscoveryHeadings();
    enhanceHomepageCustomBrand();
    setDatasetValue(document.documentElement, "homepageClarityRelease", "v17-stable-render");
  });
};

scheduleHomepageDiscoveryR2();

const popup = document.querySelector("subscription-popup.subscription-popup");

if (popup && !customElements.get("subscription-popup")) {
  setDatasetValue(popup, "triggerOpen", "scroll_down");
  setDatasetValue(popup, "repeatOpen", "every_week");
  setDatasetValue(popup, "brandUiRelease", "365nails-homepage-brand-ui-v15");
}

const dealCollection = document.querySelector(".countdown-with-multi");

if (dealCollection && !dealCollection.closest?.(".shopify-section")?.hidden) {
  const lead = dealCollection.querySelector(".countdown-with-multi__timer");
  const sourceLink = lead?.querySelector("a.card-media--link");
  const sourceEyebrow = lead?.querySelector(".rich-text__subheading")?.textContent.trim();
  const sourceHeading = lead?.querySelector(".card-media__heading")?.textContent.trim();
  const sourceDescription = lead?.querySelector(".card-media__description")?.textContent.trim();

  if (!document.querySelector(".homepage-deals-header")) {
    const header = document.createElement("div");
    const text = document.createElement("div");
    const eyebrow = document.createElement("p");
    const heading = document.createElement("h2");
    const description = document.createElement("p");
    const action = document.createElement("a");

    header.className = "homepage-deals-header";
    text.className = "homepage-deals-header__text";
    eyebrow.className = "homepage-deals-header__eyebrow";
    heading.className = "homepage-deals-header__heading";
    description.className = "homepage-deals-header__description";
    action.className = "homepage-deals-header__action";

    eyebrow.textContent = sourceEyebrow || homepageCopy(
      "homepage.products.flash_deals.eyebrow",
      "Margin-focused deals",
    );
    heading.textContent = sourceHeading || homepageCopy(
      "homepage.products.flash_deals.heading",
      "Flash Deals & Clearance Picks",
    );
    description.textContent = sourceDescription || homepageCopy(
      "homepage.products.flash_deals.description",
      "Use current clearance offers to test styles, fill bundles, and protect margin.",
    );
    action.textContent = homepageCopy(
      "homepage.products.flash_deals.action",
      "View All Deals",
    );
    action.href = localizedStorefrontPath(
      sourceLink?.getAttribute("href") || "/collections/clearance-sale",
    );

    text.append(eyebrow, heading, description);
    header.append(text, action);
    dealCollection.parentNode?.insertBefore(header, dealCollection);
  }

  const leadHeading = lead?.querySelector(".card-media__heading");
  const localizedLeadHeading = homepageCopy(
    "homepage.deals.lead_heading",
    "Clearance & Mystery Boxes",
  );
  if (leadHeading?.textContent.trim() !== localizedLeadHeading) {
    leadHeading.textContent = localizedLeadHeading;
  }

  const localizedLeadLabel = homepageCopy(
    "homepage.deals.lead_aria",
    "Shop clearance and mystery boxes",
  );
  if (sourceLink?.getAttribute("aria-label") !== localizedLeadLabel) {
    sourceLink?.setAttribute("aria-label", localizedLeadLabel);
  }

  setDatasetValue(dealCollection, "brandUiLayout", "collection-row");
}

const nailShapeOptions = [
  ["square", "Square"],
  ["almond", "Almond"],
  ["coffin", "Coffin"],
  ["oval", "Oval"],
  ["stiletto", "Stiletto"],
  ["duck", "Duck"],
  ["round", "Round"],
  ["other", "Other shapes"],
];

document.querySelectorAll(".brand-logos__items > .f-column").forEach((item, index) => {
  const option = nailShapeOptions[index];
  const link = item.querySelector(".brand-logos__image");

  if (!option || !link) return;

  const [slug, fallbackLabel] = option;
  const label = fallbackLabel;
  setDatasetValue(link, "brandShape", slug);
  setDatasetValue(link, "brandShapeLabel", label);

  const accessibleLabel = homepageCopy(
    "homepage.shapes.shop_aria",
    "Shop {{shape}} nail shapes",
    { shape: label },
  );
  if (link.getAttribute("aria-label") !== accessibleLabel) {
    link.setAttribute("aria-label", accessibleLabel);
  }
});
